export const formatNumber = (number) => {
  number = Number(number).toFixed(2);

  return number;
};
